export default __webpack_public_path__ + "static/media/read-receipt-icon.2f3ddd02.svg";